import { useEffect, useState } from "react";
import { userData, selectedOptic, formatValueUnit } from "../js/utils";
import { post } from "../js/post";
import {
  contactLensesColumnsStore,
  frameColumnsStore,
  hearingAidsColumnsStore,
  lensesFamilyStore,
  liquidColumnsStore,
  sunglassesColumnsStore,
  variousColumnsStore,
} from "../js/tableColumns";
import { focusElement } from "../js/utils";
import DataTable from "react-data-table-component";
import Dropdown from "./Dropdown";
import InputData from "./InputData";
import CheckBox from "./CheckBox";
import ButtonIconH from "./ButtonIconH";
import { TabSelector } from "./TabSelector";
import { useSuppliers } from "../hooks/useSuppliers";
import { useSupplierBrands } from "../hooks/useSupplierBrands";

export default function AssociateProduct({
  famId,
  supplier,
  brand,
  onSelect,
  category = "",
}) {
  /* const [productType, setProductType] = useState(famId); */
  const [familyId, setFamilyId] = useState(famId);
  const [inputSupplier, setInputSupplier] = useState(supplier);
  const [productList, setProductList] = useState([]);
  const [productListFiltered, setProductListFiltered] = useState([]);
  const supplierList = [
    { id: -1, text: "" },
    ...useSuppliers(familyId, "", category)[0].map((e) => ({
      id: e.id,
      text: e.nombre,
    })),
  ];
  const brandList = useSupplierBrands(
    familyId,
    inputSupplier.id !== -1 ? [inputSupplier.id] : [],
    category,
  );
  const [inputBrand, setInputBrand] = useState(brand);
  const [inputFilter, setInputFilter] = useState("");
  const [stockFilter, setStockFilter] = useState(false);
  const [discontinuedFilter, setDiscontinuedFilter] = useState(false);
  const [totalProds, setTotalProds] = useState(0);
  const [selectedPanelView, setSelectedPanelView] = useState(
    famId === 4 ? "Vista" : famId === 6 ? "Sol" : "Vista",
  );

  async function getProducts(from, total, add) {
    const response = await post("ListarProductos.php", {
      token: userData.token,
      familia: familyId,
      idProveedor: inputSupplier.id,
      marcas: inputBrand !== "" ? [inputBrand] : [],
      inputFiltro: inputFilter,
      idOptica: selectedOptic.id,
      categoria: category,
      fechaDesdeUltimaCompra: "",
      fechaHastaUltimaCompra: "",
      stockPositivo: stockFilter,
      descatalogados: discontinuedFilter,
      start: from,
      total,
    });

    // console.log(
      // "LISTANDO PRODUCTOS: ",
      // {
        // token: userData.token,
        // familia: familyId,
        // idProveedor: inputSupplier.id,
        // marcas: inputBrand !== "" ? [inputBrand] : [],
        // inputFiltro: inputFilter,
        // idOptica: selectedOptic.id,
        // categoria: category,
        // fechaDesdeUltimaCompra: "",
        // fechaHastaUltimaCompra: "",
        // stockPositivo: stockFilter,
        // descatalogados: discontinuedFilter,
        // start: from,
        // total,
      // },
      // response,
    // );

    setTotalProds(response.totalProductos);
    if (add) {
      setProductList((prev) => [...prev, ...response.productos]);
    } else setProductList(response.productos);
  }

  function getTableColumns() {
    switch (familyId) {
      case 0:
        return hearingAidsColumnsStore;
      case 1:
        return lensesFamilyStore;
      case 2:
        return contactLensesColumnsStore;
      case 3:
        return liquidColumnsStore;
      case 4:
        return frameColumnsStore;
      case 5:
        return variousColumnsStore;
      case 6:
        return sunglassesColumnsStore;
      default:
        break;
    }
  }

  useEffect(() => {
    getProducts(0, 20, false);
    focusElement(141);
  }, [familyId]);

  useEffect(() => {
    getProducts(0, 20, false);
  }, [inputSupplier, inputBrand, stockFilter, discontinuedFilter]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      getProducts(0, 20, false);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [inputFilter]);

  useEffect(() => {
    setProductListFiltered(
      productList.filter((product) => {
        return stockFilter ? product.stock > 0 : true;
      }),
    );
  }, [productList, stockFilter, discontinuedFilter]);

  return (
    <div className="extra-container" style={{ minWidth: "1330px", gap: 10 }}>
      <div className="container-panel">
        <div className="opt-table-content grid-8" id="associate-product-grid">
          <div className="cell cell-label cell-start-content">Proveedor</div>
          <div className="cell cell-start-content">
            <Dropdown
              tabIndex={141}
              optionList={supplierList}
              size={0}
              mandatory={true}
              op={inputSupplier.id}
              onChange={(e) => {
                if (e.id !== inputSupplier.id) {
                  setInputBrand("");
                }
                setInputSupplier(e);
              }}
            ></Dropdown>
          </div>
          <div className="cell"></div>
          <div className="cell cell-label cell-start-content">Marca</div>
          <div className="cell cell-start-content">
            <Dropdown
              tabIndex={142}
              optionList={
                brandList.length > 0
                  ? [{ id: "", text: "" }, ...brandList]
                  : brandList
              }
              size={0}
              op={inputBrand}
              mandatory={false}
              onChange={(e) => {
                setInputBrand(e.text);
              }}
            ></Dropdown>
          </div>
          <div className="cell"></div>
          <div className="selector-glasses-type combined-cells-2"></div>
          <div className="cell cell-label cell-start-content">
            Características
          </div>
          <div className="cell cell-start-content">
            <InputData
              tabIndex={140}
              type="type-alphanum-ext"
              size={0}
              input={inputFilter}
              onChange={(e) => {
                setInputFilter(e);
              }}
            ></InputData>
          </div>
          <div className="cell"></div>
          <div className="cell cell-label cell-start-content">
            Stock positivo
          </div>
          <div className="cell cell-start-content">
            <div
              className="data-field c-pointer"
              onClick={() => {
                setStockFilter(!stockFilter);
              }}
            >
              <CheckBox
                tabIndex={145}
                active={stockFilter}
                onClick={() => {}}
              ></CheckBox>
            </div>
            <div
              className="cell cell-label cell-start-content"
              style={{ marginLeft: 20 }}
            >
              Descatalogado
            </div>
            <div
              className="data-field c-pointer"
              onClick={() => {
                setDiscontinuedFilter(!discontinuedFilter);
              }}
            >
              <CheckBox
                tabIndex={6}
                active={discontinuedFilter}
                onClick={() => {}}
              ></CheckBox>
            </div>
          </div>
          <div className="cell combined-cells-2"></div>
        </div>
      </div>
      <div
        className="container-panel"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 20,
        }}
      >
        <div className="opt-table-title">
          <div>
            Listado de productos ({formatValueUnit(productListFiltered.length)}{" "}
            de{" "}
            <span style={{ color: "#41b3ff" }}>
              {formatValueUnit(totalProds)}
            </span>
            )
          </div>
        </div>
        {(familyId === 4 || familyId === 6) && (
          <TabSelector
            options={["Vista", "Sol"]}
            selected={selectedPanelView}
            onChange={(e) => {
              setSelectedPanelView(e);
              setFamilyId(e === "Vista" ? 4 : 6);
            }}
          />
        )}
        {selectedPanelView === "Vista" && (
          <div
            className="extra-container-info hd-table"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 20,
            }}
          >
            <DataTable
              columns={getTableColumns()}
              data={productListFiltered}
              className="custom-datatable"
              noDataComponent="No existen productos con esas características."
              onRowClicked={(row, event) => {
                onSelect(row.codigo);
              }}
            />
            <div>
              <ButtonIconH
                text="Ver más (+20)"
                small={true}
                onClick={async () =>
                  await getProducts(productListFiltered.length, 20, true)
                }
              ></ButtonIconH>
            </div>
          </div>
        )}
        {selectedPanelView === "Sol" && (
          <div
            className="extra-container-info hd-table"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 20,
              paddingBottom: 20,
            }}
          >
            <DataTable
              columns={getTableColumns()}
              data={productListFiltered}
              className="custom-datatable"
              noDataComponent="No existen productos con esas características."
              onRowClicked={(row, event) => {
                onSelect(row.codigo);
              }}
            />
            <div>
              <ButtonIconH
                text="Ver más (+20)"
                small={true}
                onClick={async () =>
                  await getProducts(productListFiltered.length, 20, true)
                }
              ></ButtonIconH>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
